import { render } from "./BlankRoute.vue?vue&type=template&id=312ab25b"
import script from "./BlankRoute.vue?vue&type=script&lang=js"
export * from "./BlankRoute.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__